/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export const SET_APP_LOADING = 'SET_APP_LOADING'
export const SET_CONFIRM_RELOAD = 'SET_CONFIRM_RELOAD'
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS'
export const SET_SCREEN = 'SET_SCREEN';

const mutations = {
  [SET_APP_LOADING](state, payload) {
    state.loading = payload
  },
  [SET_CONFIRM_RELOAD](state, payload) {
    state.confirmReload = payload
  },
  [SET_BREADCRUMBS](state, payload) {
    state.breadcrumbs = payload
  },
  [SET_SCREEN](state, payload) {
    state.screen = payload
  }
}

export default mutations

